import { useQuery } from 'react-query';

import { CommentLikers, getCommentLikers } from '../utils/backend-api/comments';

export const COMMENT_LIKERS_TEXT_KEY = 'COMMENT_LIKERS_TEXT';

export default function useCommentLikersText(commentId: number, enabled: boolean) {
  const { data, isLoading: areCommentLikersTextLoading } = useQuery<CommentLikers>(
    [COMMENT_LIKERS_TEXT_KEY, commentId],
    () => getCommentLikers(commentId, 'text'),
    {
      enabled: enabled,
    }
  );

  return { likersFor: data?.likers_for, areCommentLikersTextLoading };
}
